export default "__VITE_ASSET__e820fa2b__"